import {Component, OnInit} from '@angular/core';
import {SmartTableConfigInterface} from '../../../../shared/interface';
import {MatDialog} from '@angular/material/dialog';

import {ActivatedRoute} from '@angular/router';
import {GalleriesModel} from '../../../../shared/models/galleriesModel';
import {GalleryModel} from '../../../../shared/models/galleryModel';

import {GalleryModalComponent} from '../../../../shared/modal/gallery-modal/gallery-modal.component';
import {GalleriesService} from '../../../../shared/service/galleries.service';

@Component({
  selector: 'app-gallery-manager-page',
  templateUrl: './gallery-manager-page.component.html',
  styleUrls: ['./gallery-manager-page.component.scss']
})
export class GalleryManagerPageComponent implements OnInit {


  tableData: GalleriesModel;
  selectedGallery: GalleryModel;
  smartTableConfig: SmartTableConfigInterface;


  constructor(public dialog: MatDialog, private galleriesService: GalleriesService, private activatedRoute: ActivatedRoute) {

    this.initSmartTable();
    this.galleriesService.galleries.subscribe((galleries: GalleriesModel) => {
      this.tableData = galleries;
    });

    this.galleriesService.selectedGallery.subscribe((gallery: GalleryModel) => {
      this.selectedGallery = gallery;
    });
  }

  ngOnInit() {
    this.activatedRoute.data.subscribe(
      (data: { galleriesResolve: any }) => {
        this.tableData.items = data.galleriesResolve;
      }
    );
  }

  initSmartTable() {
    this.smartTableConfig = {
      columns: [
        {labelKey: 'COMMON.COVER_IMAGE', dataKey: 'imageUrl', isImage: true},
        {labelKey: 'REFERENCE.TITLE', dataKey: 'title', isImage: false},
      ],
      displayedColumns: ['imageUrl', 'title']
    };
  }


  openDialog(selectedGalleryModel?: GalleryModel) {

   this.dialog.open(GalleryModalComponent, {
      hasBackdrop: true,
      width: '60vw',
      data: selectedGalleryModel ? selectedGalleryModel : new GalleryModel()
    });

  }


  deleteItem(event) {
    this.galleriesService.deleteGallery(event.item, event.dialogRef);
  }

}
